export default {
  footer: {
    poweredBy: "Powered by",
    help: "Help",
  },

  // Guided tour (optional editor `tour` config)
  tour: {
    next: "Next",
    skip: "Skip tour",
    done: "Got it!",
    stepCounter: "{current} of {total}",
    defaults: {
      canvas: {
        title: "Your email canvas",
        text: "This is where your email takes shape. Click any block to select and edit it.",
      },
      sidebar: {
        title: "Block library",
        text: "Drag blocks from here onto the canvas to add text, images, buttons, and more.",
      },
      rightSidebar: {
        title: "Content & settings",
        text: "Select a block to edit its content here, or switch to Settings to adjust the overall template layout.",
      },
    },
  },

  // History (undo/redo)
  history: {
    undo: "Undo",
    redo: "Redo",
    collabWarning: "Undo may affect collaborators' recent changes",
  },

  // Viewport toggle
  viewport: {
    label: "Viewport",
    desktop: "Desktop",
    tablet: "Tablet",
    mobile: "Mobile",
  },

  // Dark mode preview
  darkMode: {
    enable: "Dark Mode Preview",
    disable: "Light Mode Preview",
  },

  // Preview mode
  previewMode: {
    enable: "Preview Mode",
    disable: "Exit Preview",
  },

  // Sidebar - Block types
  blocks: {
    section: "Section",
    image: "Image",
    title: "Title",
    paragraph: "Paragraph",
    button: "Button",
    input: "Input",
    divider: "Divider",
    video: "Video",
    social: "Social",
    spacer: "Spacer",
    html: "HTML",
    menu: "Menu",
    table: "Table",
    countdown: "Countdown",
    form: "Form",
    discountCoupon: "Discount coupon",
  },

  // Right sidebar
  sidebar: {
    content: "Content",
    settings: "Settings",
    noSelection: "No element selected",
    noSelectionHint: "Select a block on the canvas to edit it",
  },

  // Toolbar - Common
  toolbar: {
    duplicate: "Duplicate",
    delete: "Delete",
  },

  // Title editor toolbar
  titleEditor: {
    toolbar: "Title formatting",
    bold: "Bold (Ctrl+B)",
    italic: "Italic (Ctrl+I)",
    addLink: "Add Link",
  },

  // Paragraph editor toolbar
  paragraphEditor: {
    toolbar: "Text formatting",
    bold: "Bold (Ctrl+B)",
    italic: "Italic (Ctrl+I)",
    underline: "Underline (Ctrl+U)",
    strikethrough: "Strikethrough",
    subscript: "Subscript",
    superscript: "Superscript",
    addLink: "Add Link",
    bulletList: "Bullet List",
    numberedList: "Numbered List",
    alignLeft: "Align Left",
    alignCenter: "Align Center",
    alignRight: "Align Right",
    clearFormatting: "Clear Formatting",
    insertEmoji: "Insert Emoji",
    fontFamily: "Font Family",
    defaultFont: "Default",
    fontSize: "Font Size",
    defaultSize: "Default",
    textColor: "Text Color",
    highlightColor: "Highlight Color",
    lineHeight: "Line Height",
    letterSpacing: "Letter Spacing",
    emojiItemLabel: "Insert emoji {emoji}",
    closeEmojiPicker: "Close emoji picker",
  },

  // Block actions (BlockWrapper)
  blockActions: {
    drag: "Drag to reorder, or press Space to move with keyboard",
    dragLifted:
      "Moving {block}. Use up and down arrow keys to reposition, Space or Enter to drop, Escape to cancel.",
    duplicate: "Duplicate block",
    delete: "Delete block",
    hiddenOnViewport: "Hidden on {viewport}",
    saveAsModule: "Save as Module",
    conditionToggle: "Toggle display condition",
    comments: "Comments ({count})",
    lifted: "{block} lifted. Position {position} of {total}.",
    moved: "{block} moved to position {position} of {total}.",
    dropped: "{block} dropped at position {position} of {total}.",
    cancelled: "Move cancelled. {block} returned to position {position}.",
  },

  // Toolbar - Section
  section: {
    dropHere: "Drop blocks here",
    columns: "Columns",
    column1: "1 Column",
    column2: "2 Columns",
    column3: "3 Columns",
    ratio12: "1:2 Ratio",
    ratio21: "2:1 Ratio",
  },

  // Text editor link dialog
  linkDialog: {
    editLink: "Edit Link",
    insertLink: "Insert Link",
    updateLink: "Update Link",
    removeLink: "Remove Link",
    cancel: "Cancel",
    urlPlaceholder: "https://example.com",
    urlLabel: "URL",
  },

  // Toolbar - Title
  title: {
    level: "Heading Level",
    heading1: "Heading 1 (36px)",
    heading2: "Heading 2 (28px)",
    heading3: "Heading 3 (22px)",
    heading4: "Heading 4 (18px)",
    fontFamily: "Font Family",
    inheritFont: "Use template font",
    color: "Color",
    align: "Align",
    alignLeft: "Left",
    alignCenter: "Center",
    alignRight: "Right",
  },

  // Emoji picker
  emoji: {
    smileys: "Smileys",
    gestures: "Gestures",
    objects: "Objects",
  },

  // Toolbar - Image
  image: {
    imageUrl: "Image URL",
    imageUrlPlaceholder: "https://...",
    altText: "Alt Text",
    altTextPlaceholder: "Image description",
    width: "Width",
    fullWidth: "Full Width",
    linkUrl: "Link URL",
    openInNewTab: "Open in new tab",
    placeholderUrl: "Placeholder Image",
    placeholderUrlPlaceholder: "https://... (design-time only)",
    placeholderUrlTooltip:
      "Since the image URL uses a merge tag, you can provide a real image here to preview the layout while designing. This is not included in the final output.",
    clickToAdd: "Click to add image URL",
    browseMedia: "Browse Media",
    decorative: "Decorative image",
    decorativeHint:
      "Hidden from screen readers. Use only for spacers and visual flourishes.",
  },

  // Toolbar - Video
  video: {
    videoUrl: "Video URL",
    videoUrlPlaceholder: "https://youtube.com/...",
    youtube: "YouTube",
    vimeo: "Vimeo",
    detected: "Video detected — thumbnail will be generated automatically",
    openInNewTab: "Open in new tab",
    customThumbnail: "Custom Thumbnail",
    optional: "(optional)",
    thumbnailPlaceholder: "Auto-generated from video URL",
    altText: "Alt Text",
    altTextPlaceholder: "Video description",
    width: "Width",
    fullWidth: "Full Width",
    placeholderUrl: "Placeholder Thumbnail",
    placeholderUrlPlaceholder: "https://... (design-time only)",
    placeholderUrlTooltip:
      "Since the video URL uses a merge tag, you can provide a real thumbnail here to preview the layout while designing. This is not included in the final output.",
    addVideo: "Add a video URL",
  },

  // Toolbar - Button
  button: {
    fontFamily: "Font Family",
    inheritFont: "Use template font",
    text: "Text",
    actionOnClick: "Action on click",
    clickActionNone: "Select action",
    clickActionNextStep: "Show next step",
    clickActionPreviousStep: "Show previous step",
    clickActionLoadPage: "Load new page",
    clickActionScrollAnchor: "Scroll to anchor",
    clickActionClosePopup: "Close the popup",
    url: "URL",
    pageUrl: "Page URL",
    anchorId: "Anchor ID",
    anchorIdPlaceholder: "section-id",
    urlPlaceholder: "https://...",
    openInNewTab: "Open in new tab",
    background: "Background",
    textColor: "Text Color",
    border: "Border",
    borderColor: "Border color",
    borderWidth: "Border width",
    borderSides: "Sides",
    borderSidesLabels: {
      all: "All sides",
      top: "Top",
      right: "Right",
      bottom: "Bottom",
      left: "Left",
    },
    borderRadius: "Border Radius",
    fontSize: "Font Size",
  },

  // Toolbar - Input field
  input: {
    fieldType: "Input type",
    types: {
      text: "Text",
      email: "Email",
      date: "Date",
    },
    name: "Field name",
    label: "Label",
    placeholder: "Placeholder",
    defaultValue: "Default value",
    required: "Required",
    labelAppearance: "Label styling",
    labelMargin: "Label margin",
    labelPadding: "Label padding",
    fontFamily: "Font family",
    inheritFont: "Use template font",
    fontWeight: "Font weight",
    weightNormal: "Normal",
    weightBold: "Bold",
    alignLeft: "Left",
    alignCenter: "Center",
    alignRight: "Right",
    inputAppearance: "Input styling",
    inputMargin: "Input margin",
    inputPadding: "Input padding",
    fieldWidth: "Width",
    fixedWidth: "Fixed width",
    placeholderColor: "Placeholder color",
  },

  // Toolbar - Form (multi-field opt-in)
  form: {
    tabs: {
      sync: "Sync",
      fields: "Fields",
      button: "Button",
      terms: "Terms",
    },
    sync: {
      heading: "Pick your marketing platform",
    },
    fieldTypes: {
      firstName: "First name",
      lastName: "Last name",
      email: "Email",
      phone: "Phone",
    },
    fields: {
      addField: "Add field",
      noMoreFields: "All field types added",
      cancel: "Cancel",
      remove: "Remove field",
      label: "Label",
      labelPlaceholder: "What is your email?",
      optional: "optional",
      placeholder: "Placeholder",
      name: "Field name",
      required: "Field is required",
      blockExisting: "Block existing emails",
      blockExistingHint:
        "Prevent signing up with the emails you've already collected.",
      blockExistingAll: "Check across all my campaigns",
      blockExistingThis: "Check only this campaign",
      errorMessage: "Error message",
    },
    button: {
      submitText: "Submit button",
      actionOnClick: "Action on click",
      url: "Page URL",
      position: "Position",
      oneLine: "One line",
      twoLines: "Two lines",
      background: "Background",
      textColor: "Text color",
      borderRadius: "Border radius",
    },
    buttonActions: {
      nextStep: "Show next step",
      closePopup: "Close the popup",
      loadPage: "Load new page",
      none: "Do nothing",
    },
    terms: {
      enable: "Show terms",
      content: "Terms content",
      htmlHint: "HTML is allowed. Use links and small print as needed.",
    },
  },

  // Toolbar — Discount coupon (Shopify-style subscribe discount)
  discountCoupon: {
    description: "Attract customers to subscribe with a discount code.",
    modeNone: "No discount",
    modeAuto: "Discount code",
    modeManual: "Enter Shopify discount manually",
    autoHint:
      "Auto-generate a unique and non-reusable code for each subscription.",
    dynamicModesRequirePriorFormHint:
      "The dynamic code is available only after the opt-in step.",
    selectType: "Select type",
    types: {
      percentageOff: "Percentage off",
      fixedAmount: "Fixed amount",
      freeShipping: "Free shipping",
    },
    value: "Value",
    currencyCode: "Currency",
    expiration: "Set expiration on discount",
    expirationDaysSuffix: "Days",
    tagCustomer: "Add the sent discount code as a tag to the customer",
    combinations: "Combinations",
    combineProduct: "Product discounts",
    combineOrder: "Order discounts",
    combineShipping: "Shipping discounts",
    manualPlaceholder: "Discount code",
    manualFooterLead: "Create a discount",
    manualFooterTail: " in your Shopify admin, and enter it above.",
    manualBlankError: "This field can't be blank",
    confirmationTextLabel: "Confirmation text",
    afterClickLabel: "After click",
    afterClickNone: "Do nothing",
    afterClickLoadPage: "Go to URL",
    afterClickCloseCampaign: "Close campaign",
    afterClickNextStep: "Show next step",
    afterClickPageUrl: "Page URL",
    afterClickUrlPlaceholder: "https://...",
    previewNoDiscount: "No discount",
    previewPercentage: "{value}% off",
    previewFixed: "{value} {currency} off",
    previewAutoUnique: "Unique code per subscription",
    previewManualPrefix: "Code:",
    previewManualUnset: "Enter a Shopify discount code",
    previewExpires: "Expires after {days} day(s)",
    previewTag: "Tag customer with code",
    previewCombinations: "Combines with product / order / shipping discounts",
    previewSampleCode: "THANKYOU20",
    copyCode: "Copy code",
    copyCodeFlash: "Copied",
  },

  // Toolbar - Divider
  divider: {
    style: "Style",
    solid: "Solid",
    dashed: "Dashed",
    dotted: "Dotted",
    color: "Color",
    thickness: "Thickness",
  },

  // Toolbar - Social Icons
  social: {
    icons: "Icons",
    addIcon: "Add Icon",
    addIcons: "Add social icons",
    removeIcon: "Remove",
    platform: "Platform",
    url: "URL",
    urlPlaceholder: "https://...",
    style: "Style",
    styleSolid: "Solid",
    styleOutlined: "Outlined",
    styleRounded: "Rounded",
    styleSquare: "Square",
    styleCircle: "Circle",
    size: "Size",
    sizeSmall: "S",
    sizeMedium: "M",
    sizeLarge: "L",
    spacing: "Spacing",
    align: "Alignment",
    platforms: {
      facebook: "Facebook",
      twitter: "X (Twitter)",
      instagram: "Instagram",
      linkedin: "LinkedIn",
      youtube: "YouTube",
      tiktok: "TikTok",
      pinterest: "Pinterest",
      email: "Email",
      whatsapp: "WhatsApp",
      telegram: "Telegram",
      discord: "Discord",
      snapchat: "Snapchat",
      reddit: "Reddit",
      github: "GitHub",
      dribbble: "Dribbble",
      behance: "Behance",
    },
  },

  // Toolbar - Menu
  menu: {
    items: "Menu Items",
    addItem: "Add Item",
    removeItem: "Remove",
    text: "Text",
    url: "URL",
    urlPlaceholder: "https://example.com",
    openInNewTab: "Open in new tab",
    bold: "Bold",
    underline: "Underline",
    color: "Color",
    linkColor: "Link Color",
    fontSize: "Font Size",
    fontFamily: "Font Family",
    separator: "Separator",
    separatorColor: "Separator Color",
    spacing: "Spacing",
    textAlign: "Alignment",
    addLinks: "Add menu links",
  },

  // Toolbar - Table
  table: {
    dimensions: "Dimensions",
    rows: "Rows",
    columns: "Columns",
    addRow: "Add Row",
    removeRow: "Remove Row",
    addColumn: "Add Column",
    removeColumn: "Remove Column",
    hasHeaderRow: "Header row",
    headerBackgroundColor: "Header Background",
    noHeaderBg: "No background",
    borderColor: "Border Color",
    borderWidth: "Border Width",
    cellPadding: "Cell Padding",
    fontFamily: "Font Family",
    fontSize: "Font Size",
    color: "Text Color",
    textAlign: "Alignment",
    cellPlaceholder: "Enter text...",
    empty: "Add a table",
  },

  // Toolbar - Spacer
  spacer: {
    height: "Height",
  },

  // Toolbar - Countdown
  countdown: {
    targetDate: "Target Date",
    timezone: "Timezone",
    display: "Display",
    days: "Days",
    hours: "Hours",
    minutes: "Minutes",
    seconds: "Seconds",
    separator: "Separator",
    fontFamily: "Font Family",
    inheritFont: "Default",
    digitFontSize: "Digit Size",
    digitColor: "Digit Color",
    labelColor: "Label Color",
    labelFontSize: "Label Size",
    background: "Background",
    labels: "Labels",
    expiry: "Expired Message",
    expiredMessagePlaceholder: "This offer has expired",
    expiredImageUrl: "Expired Image URL",
    hideOnExpiry: "Hide when expired",
    setDate: "Set a target date in the settings panel",
    hidden: "Hidden (expired)",
    style: "Style",
    layout: "Layout",
    animationSpeed: "Animation Speed",
    accentColor: "Accent Color",
    cardGap: "Card Gap",
    cardRadius: "Card Radius",
    enableHoverFx: "Enable hover effects",
  },

  // Custom Blocks
  customBlocks: {
    definitionNotFound: "Unknown block type — this block is not registered",
    renderError:
      "This block could not be rendered. Check the block template for errors.",
    fields: {
      required: "Required",
      addItem: "Add item",
      removeItem: "Remove",
      maxItemsReached: "Maximum items reached",
      minItemsRequired: "Minimum {count} items required",
    },
    toolbar: {
      noDefinition:
        "Register this block type in your SDK configuration to edit its properties",
    },
    dataSource: {
      fetchButton: "Load content",
      changeButton: "Change",
      fetching: "Loading...",
      readOnlyTooltip: "This value is loaded from your data source",
      fetchError: "Failed to load content",
    },
  },

  // Toolbar - HTML
  html: {
    content: "HTML Content",
    preview: "Custom HTML block",
    empty: "Add HTML content in the panel",
    sanitizationHint: "Scripts and unsafe elements are removed on export.",
  },

  // Toolbar - Common block settings
  blockSettings: {
    spacing: "Spacing",
    padding: "Padding",
    margin: "Margin",
    background: "Background",
    color: "Color",
    display: "Display",
    showOnDesktop: "Show on desktop",
    showOnTablet: "Show on tablet",
    showOnMobile: "Show on mobile",
    hiddenOnDevice: "Hidden on {device}",
    customCss: "Custom CSS",
    css: "CSS",
    cssPlaceholder: "/* Custom styles */",
    displayCondition: "Display Condition",
    selectCondition: "Select condition",
    removeCondition: "Remove condition",
    noCondition: "Always visible",
    conditionApplied: "Condition applied",
    customCondition: "Custom condition",
    customConditionLabel: "Condition name",
    customConditionBefore: "Before (opening logic)",
    customConditionAfter: "After (closing logic)",
    applyCondition: "Apply",
    cancelCondition: "Cancel",
    customBadge: "Custom",
    restoreHiddenBlocks: "Show all hidden blocks",
  },

  // Template settings
  templateSettings: {
    layout: "Layout",
    widthPreset: "Width Preset",
    customWidth: "Custom Width",
    contentPadding: "Padding",
    appearance: "Appearance",
    backgroundColor: "Background Color",
    backgroundOpacity: "Background Opacity",
    backgroundShadow: "Background Shadow",
    fontFamily: "Font Family",
    preheaderText: "Preheader Text",
    preheaderTextPlaceholder:
      "Preview text shown after subject line in inbox...",
    preheaderTextHint:
      "This text appears after the subject line in email client previews. Supports merge tags.",
    language: "Language",
    contentLocale: "Content language",
    contentLocaleHint:
      "BCP 47 code (e.g. en, de, pt-BR). Sets the rendered email's lang attribute so screen readers pronounce content correctly.",
    tips: "Tips",
    tip1: "600px is the standard width for email templates",
    tip2: "Use web-safe fonts for best compatibility",
    tip3: "Light backgrounds work best for readability",
  },

  // Spacing control
  spacingControl: {
    lockAll: "Lock all sides",
    unlock: "Unlock sides",
    top: "Top",
    right: "Right",
    bottom: "Bottom",
    left: "Left",
    decreaseTop: "Decrease top",
    increaseTop: "Increase top",
    decreaseLeft: "Decrease left",
    increaseLeft: "Increase left",
    decreaseRight: "Decrease right",
    increaseRight: "Increase right",
    decreaseBottom: "Decrease bottom",
    increaseBottom: "Increase bottom",
  },

  // Color Picker
  colorPicker: {
    pickColor: "Pick a color",
    hexValue: "Hex color value",
  },

  // Merge Tag
  mergeTag: {
    clickToEdit: "Click to edit",
    remove: "Remove merge tag",
    insert: "Insert merge tag",
    add: "Add merge tag",
    editValue: "Edit merge tag value",
    deleteMergeTag: "Delete merge tag",
    suggestionEmpty: "No matching merge tags",
  },

  // Canvas
  canvas: {
    noBlocks: "No blocks yet",
    dragHint: "Start from scratch by dragging blocks from the sidebar",
    dropHere: "Drop here",
    aiHintChat: "or let",
    aiHintChatSuffix: "generate a complete template for you in seconds",
    aiHintDesign:
      "Have an existing design? Upload a screenshot, image, or PDF and",
    aiHintDesignSuffix: "will instantly recreate it",
    pages: {
      ariaStrip: "Canvas steps",
      addStep: "Add step",
      stepActions: "Step actions",
      rename: "Rename",
      delete: "Delete",
      renamePrompt: "Step name",
      unreachableLabel: "Unreachable step",
      unreachableTooltip:
        "This step is unreachable. The previous step has no Button or Form block configured with “Show next step” (or equivalent) that leads here.",
    },
  },

  // Media Library (cloud)
  mediaLibrary: {
    title: "Media Library",
    searchPlaceholder: "Search files...",
    allFiles: "All Files",
    filterAll: "All Types",
    filterImages: "Images",
    filterDocuments: "Documents",
    filterVideos: "Videos",
    filterAudio: "Audio",
    newFolder: "New Folder",
    folderName: "Folder name",
    noFiles: "No files found",
    dropOrClick: "Drop files here or click to upload",
    acceptedFormats: "Images, PDF, Video, Audio, Documents (max 10MB)",
    uploading: "Uploading...",
    uploadingProgress: "Uploading {current} of {total}...",
    selectImage: "Select Image",
    selectFile: "Select File",
    deleteSelected: "Delete",
    copyUrl: "Copy URL",
    copied: "Copied!",
    browseMedia: "Browse Media Library",
    renameFolder: "Rename folder",
    addSubfolder: "Add subfolder",
    subfolderName: "Subfolder name",
    sortNewest: "Newest First",
    sortOldest: "Oldest First",
    sortNameAsc: "Name A-Z",
    sortNameDesc: "Name Z-A",
    sortSizeAsc: "Smallest First",
    sortSizeDesc: "Largest First",
    moveSelected: "Move",
    moveToRoot: "All Files",
    currentFolder: "(current)",
    confirmDelete: "Delete this file?",
    renameFile: "Rename",
    editFile: "Edit File",
    fileName: "Filename",
    altText: "Alt Text",
    altTextPlaceholder: "Describe this image for accessibility",
    saveChanges: "Save",
    cancel: "Cancel",
    frequentlyUsed: "Frequently Used",
    deleteWarningTitle: "Delete File",
    deleteWarningMessage:
      "This file will be permanently deleted and cannot be recovered.",
    deleteWarningUsageNote:
      "The following files are used in templates. Deleting them may break those templates.",
    deleteAnyway: "Delete file",
    usedInTemplates: "Used in {count} template(s)",
    viewGrid: "Grid view",
    viewList: "List view",
    showFolders: "Show folders",
    hideFolders: "Hide folders",
    importFromUrl: "Import from URL",
    importUrlPlaceholder: "https://example.com/image.jpg",
    import: "Import",
    importing: "Importing...",
    importError: "Failed to import from URL",
    conversionLabel: "Size",
    conversionOriginal: "Original",
    conversionSmall: "Small (150px)",
    conversionMedium: "Medium (600px)",
    conversionLarge: "Large (1200px)",
    replaceFile: "Replace File",
    replaceWarningTitle: "Replace File",
    replaceWarningMessage:
      "You are about to replace this file. The replacement must have the same file extension ({extension}).",
    replaceWarningUsageNote:
      "This file is used in {count} template(s). Replacing it will update all references.",
    replaceSelectFile: "Select replacement file",
    replace: "Replace",
    replacing: "Replacing...",
    replaceError: "Failed to replace file",
    saving: "Saving...",
    cropAspectRatio: "Aspect Ratio",
    cropFree: "Free",
    cropSquare: "1:1",
    cropLandscape43: "4:3",
    cropLandscape169: "16:9",
    cropOriginal: "Original",
    cropMaxWidth: "Max Width",
    cropMaxHeight: "Max Height",
    cropOutputSize: "Output Size",
    cropPixels: "px",
    cropOptional: "(optional)",
    storageTooltip: "{used} of {total} used ({remaining} remaining)",
  },

  // Sidebar & popup chrome (icon rail)
  popupSidebar: {
    workspaceLabel: "Popup editor tools",
    railNavLabel: "Editor sections",
    railDesign: "Design",
    railBlocks: "Blocks",
    railDisplayRules: "Display rules",
    railSchedule: "Schedule",
    placeholderDesign: "Design controls will appear here.",
    placeholderDisplayRules: "Display rules will appear here.",
    placeholderSchedule: "Scheduling options will appear here.",
  },

  popupSchedule: {
    timeZone: "Time zone",
    startDate: "Start date",
    endDate: "End date",
    startImmediate: "Immediate",
    endNone: "None",
    clearStartDate: "Clear start date",
    clearEndDate: "Clear end date",
    needHelp: "I need help",
    detailedSchedule: "Detailed schedule",
    detailedScheduleHeading: "Detailed schedule",
    removeSlot: "Remove time slot",
    addTimeSlot: "+ Add a time slot",
    calendarPrevMonth: "Previous month",
    calendarNextMonth: "Next month",
    calendarToday: "Today",
    calendarClear: "Clear date",
    calendarDialogLabel: "Choose date",
    dayLabels: {
      everyday: "Everyday",
      monday: "Monday",
      tuesday: "Tuesday",
      wednesday: "Wednesday",
      thursday: "Thursday",
      friday: "Friday",
      saturday: "Saturday",
      sunday: "Sunday",
    },
  },

  popupDisplayRules: {
    debug: "Debug",
    tabTrigger: "Trigger",
    tabPages: "Pages",
    tabAudience: "Audience",
    tabFrequency: "Frequency",
    tabAdvanced: "Advanced",
    placeholderSubtab: "This section will be available in a future update.",
    triggerHeading: "Trigger",
    triggerIntro: "Choose when your visitors will see this campaign.",
    triggerIntroSecondary:
      "Enable multiple triggers to fire on whichever condition is met first.",
    learnMore: "Learn more",
    addTriggerConditions: "Add trigger conditions",
    triggerShowOnlyAfter: "Show only after",
    triggerSecondsOnPage: "seconds on page",
    triggerPageViewsSuffix: "page views",
    triggerAddRule: "Add rule",
    triggerRemoveRuleAria: "Remove page views rule",
    triggerOperatorGroupAria: "Combine delay and page views",
    operatorAndShort: "AND",
    operatorOrShort: "OR",
    triggerDelaySeconds: "Delay (seconds)",
    triggerPageViews: "Minimum page views",
    triggerOperator: "Combine rules with",
    operatorAnd: "All (AND)",
    operatorOr: "Any (OR)",
    triggerOnScrollUpLabel: "Trigger when scrolling up(Mobile & Tablet)",
    triggerOnBackButtonLabel: "Trigger on browser back(Mobile)",
    debugJsonTitle: "Triggers JSON (embed shape)",
    debugJsonHint:
      "Short keys (landing, exit, scroll, …) for runtimes and integrations. Editor still stores onLanding, onExit, …",
    copyJson: "Copy JSON",
    copyJsonDone: "Copied",
    debugJsonClose: "Close",
    scrollShowAfter: "Show after scrolling",
    scrollPercentSuffix: "% of the screen",
    clickHint:
      'Append this fragment to your link href to trigger the popup. Example: <a href="#popup"></a>',
    hoverPlaceholder: "ID of an element",
    help: "Help",
    customEventLabel: "Event name",
    customEventPlaceholder: "myPopupOpen",
    triggerOnLandingTitle: "On Landing",
    triggerOnLandingDesc: "When a visitor loads a page.",
    triggerOnExitTitle: "On Exit (exit intent)",
    triggerOnExitDesc:
      "When a visitor moves to leave the page — show the popup before they go.",
    triggerOnScrollTitle: "On Scroll",
    triggerOnScrollDesc: "When a visitor scrolls down.",
    triggerOnClickTitle: "On Click",
    triggerOnClickDesc: "When a visitor clicks a link.",
    triggerOnHoverTitle: "On Hover",
    triggerOnHoverDesc: "When a visitor hovers over an element.",
    triggerOnCustomTitle: "On Custom Event",
    triggerOnCustomDesc: "Use your own trigger.",
    frequencyHeading: "Frequency",
    frequencyIntro: "Choose how often your visitors will see this campaign.",
    frequencyShowAgainTitle: "Show again",
    frequencyShowAgainDesc: "Set how frequently your campaign will display.",
    frequencyEveryPageLoad: "Every page load",
    frequencyEverySession: "Every session",
    frequencyEveryPrefix: "Every",
    frequencyIntervalUnitMinutes: "Minutes",
    frequencyIntervalUnitHours: "Hours",
    frequencyIntervalUnitDays: "Days",
    frequencyStopShowingTitle: "Stop showing",
    frequencyStopShowingDesc:
      "Set when a visitor should stop seeing your campaign.",
    frequencyStopAfterSignup: "After a visitor has signed up or clicked",
    frequencyStopAfterSeen: "After a visitor has seen the campaign",
    frequencyStopTimesSuffix: "times",
    frequencyStopAfterClosedPrefix: "After a visitor has closed the campaign,",
    frequencyClosedNeverAgain: "and never display again",
    frequencyClosedRespectRules: "but respect show again rules above",
    frequencyAfterClosedHelp:
      "Defines what happens after someone closes the popup without signing up or clicking.",
  },

  popupDesign: {
    tabStyle: "Style",
    tabPosition: "Position",
    tabClosing: "Closing",
    tabCss: "CSS",
    placeholderSubtab:
      "CSS customization will be available in a future update.",
    standardSize: "Standard size",
    shapeHeading: "Panel shape",
    shapeLabels: {
      normal: "Normal",
      circle: "Circle",
      semiCircle: "Semi-circle",
      triangle: "Triangle",
      pill: "Pill",
      hexagon: "Hexagon",
      diamond: "Diamond",
    },
    panelAppearance: "Panel appearance",
    panelColorHint:
      "Solid fill uses the template background color from the Settings tab.",
    panelBackgroundOpacity: "Panel fill opacity",
    contentScrimOpacity: "Content scrim",
    backgroundImageUrl: "Background image URL",
    backgroundImageFitHeading: "Background image fit",
    fitAuto: "Auto (natural ratio)",
    fitCover: "Cover",
    fitContain: "Contain",
    backgroundImageOnly: "Image only (hide body chrome)",
    options: "Options",
    useOverlay: "Use overlay",
    overlayBlur: "Background blur",
    overlayBlurHint:
      "Blurs whatever is behind the popup. Drag to 0 for a sharp backdrop.",
    overlayImageOpacity: "Overlay image opacity",
    overlayImage: "Overlay image",
    overlayImagePanelAriaLabel: "Overlay image upload",
    overlayImageDropLineBefore: "Drag your image here or ",
    overlayImageBrowse: "browse",
    overlayImageDropLineAfter: ".",
    overlayImageFormats: "JPEG, PNG, GIF, WebP, AVIF or SVG.",
    overlayImageDesktopPreview: "Desktop overlay preview",
    overlayImageMobilePreview: "Mobile overlay preview",
    overlayImageCrop: "Crop",
    overlayImageReplace: "Replace",
    overlayImageRemove: "Remove",
    backgroundImage: "Background image",
    multiColumn: "Multiple columns layout",
    rtl: "Activate right-to-left",
    positionHeading: "Select where your popup will be displayed",
    displayAnimationHeading: "Select a display animation",
    animationSmooth: "Smooth",
    animationFadeIn: "Fade in",
    animationSlideIn: "Slide in",
    animationNone: "None",
    positionLabels: {
      topLeft: "Top left",
      topCenter: "Top center",
      topRight: "Top right",
      middleLeft: "Middle left",
      center: "Center",
      middleRight: "Middle right",
      bottomLeft: "Bottom left",
      bottomCenter: "Bottom center",
      bottomRight: "Bottom right",
    },
    closingDisplayCloseButton: "Display closing button",
    closingButtonPosition: "Closing button position",
    closingButtonPositionLeft: "Left",
    closingButtonPositionRight: "Right",
    closingOnOverlayClick: "Close when overlay is clicked",
    sizeLabels: {
      small: "Small",
      medium: "Medium",
      large: "Large",
      fullscreen: "Full screen",
      fullHeight: "Full height",
      custom: "Custom",
    },
  },

  sidebarNav: {
    browseModules: "Browse saved modules",
    expandSidebar: "Expand block sidebar",
    palette: "Block palette",
    insertBlock: "Insert {block} block",
    paletteDiscountCouponTaken:
      "Only one discount coupon is allowed across all steps.",
    paletteFormTaken: "Only one form block is allowed across all steps.",
  },

  // Landmark region labels for assistive technology
  landmarks: {
    canvas: "Email canvas",
    blockToolbar: "Block properties",
    rightSidebar: "Block properties and template settings",
    reorderAnnouncements: "Block reorder announcements",
  },

  // Design Reference (cloud)
  errors: {
    editorLoading: "Loading editor...",
    editorLoadFailed: "Failed to load editor.",
    retry: "Retry",
  },

  accessibility: {
    panelTitle: "Accessibility",
    panelTabLabel: "Accessibility",
    groupErrors: "Errors",
    groupWarnings: "Warnings",
    groupInfo: "Info",
    jump: "Jump to block",
    fix: "Fix",
    emptyState: "No accessibility issues — looking good.",
    badgeError: "Has accessibility errors",
    badgeWarning: "Has accessibility warnings",
    issueCountTooltip: "{count} accessibility issue(s)",
  },
};
